import { loadTranslations, setLocale as reduxSetLocale } from 'react-redux-i18n'
import { createActionThunk } from 'redux-thunk-actions'
import { createAction, handleActions } from 'redux-actions'

import api from 'core/api'
import translationsSelector from 'selectors/translations'

const getType = type => `@translations/${type}`

export const getTranslations = createActionThunk(getType('FETCH'), api('/translations'))

export const toggleLanguageDialog = createAction(getType('TOGGLE_LANGUAGE_DIALOG'))

export const toggleMobileMenu = createAction(getType('TOGGLE_MOBILE_MENU'))

export const setLocale = locale => (dispatch, getState) => {
  dispatch(reduxSetLocale(locale))
  dispatch(getTranslations()).then(() => {
    dispatch(loadTranslations(translationsSelector(getState())))
  })
}

const initialState = { json: {}, language_dialog_opened: false, mobile_menu_opened: false }

export default handleActions(
  {
    [getTranslations.START]: state => ({ ...state, loading: true }),
    [getTranslations.SUCCEEDED]: (state, { payload: { json } }) => ({ ...state, json }),
    '@@i18n/LOAD_TRANSLATIONS': state => ({ ...state, loading: false }),
    [toggleLanguageDialog]: state => ({
      ...state,
      language_dialog_opened: !state.language_dialog_opened
    }),
    [toggleMobileMenu]: state => ({
      ...state,
      mobile_menu_opened: !state.mobile_menu_opened
    })
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/modules/translations.js